// LOCAL URL
 var googleClientId = "587221657973-vpn1art75mpiqsme2e1v7i6ojrenqnu2.apps.googleusercontent.com";
export default googleClientId;